import { render, staticRenderFns } from "./PerformanceInfo.vue?vue&type=template&id=307cc932&scoped=true"
import script from "./PerformanceInfo.vue?vue&type=script&lang=js"
export * from "./PerformanceInfo.vue?vue&type=script&lang=js"
import style0 from "./PerformanceInfo.vue?vue&type=style&index=0&id=307cc932&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307cc932",
  null
  
)

export default component.exports